// extracted by mini-css-extract-plugin
export default {"projectContainer":"project_projectContainer__cLmzC","projectContent":"project_projectContent__8134W","projectTitle":"project_projectTitle__y7apa"};